import { render, staticRenderFns } from "./Trailers.vue?vue&type=template&id=e38f0568&scoped=true"
import script from "./Trailers.vue?vue&type=script&lang=js"
export * from "./Trailers.vue?vue&type=script&lang=js"
import style0 from "./Trailers.vue?vue&type=style&index=0&id=e38f0568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38f0568",
  null
  
)

export default component.exports